import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { ComponentTypeModel } from '../models'
import { MainPart } from './main-part.service'

export interface ComponentType extends ComponentTypeModel {
    key?: string
    new?: boolean
}

const url = `/libraries/management/types/componentType/entries`

@Injectable()
export class ComponentTypeService {
    constructor(private http: HttpService) {}

    getAll(): Observable<ComponentType[]> {
        return this.http.get(url)
    }

    remove(data: ComponentType[]): Observable<boolean> {
        return this.http.delete(url, { data })
    }

    create(data: ComponentType[]): Observable<unknown> {
        return this.http.post(url, { data })
    }
    update(data: ComponentType[]): Observable<unknown> {
        return this.http.put(url, { data })
    }
}
